import { render, staticRenderFns } from "./PartnerDeletePopup.vue?vue&type=template&id=27805028&"
import script from "./PartnerDeletePopup.vue?vue&type=script&lang=js&"
export * from "./PartnerDeletePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports